const resources = {
    allTopics: 'All Topics'
};

export default function getResource(label) {
    return resources[label];
}
